module.exports = __webpack_public_path__ + "assets/e45172e43fedfd2fa0be33b9a404b1d8.mp3";